export default __webpack_public_path__ + "static/media/road-I-photo.e591cb17.svg";